import { render, staticRenderFns } from "./Bahn1Gallery.vue?vue&type=template&id=50e52270&scoped=true&"
import script from "./Bahn1Gallery.vue?vue&type=script&lang=js&"
export * from "./Bahn1Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1Gallery.vue?vue&type=style&index=0&id=50e52270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e52270",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
